export default "__VITE_ASSET__8945322b__"